import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProgressTypeDto } from '../models/progress-type-dto.model';
import { ApiServiceBase } from './base/api-service-base';

@Injectable({ providedIn: 'root' })
export class ProgressTypeService extends ApiServiceBase {
  //#region Constructor
  constructor(
    private readonly _httpClient: HttpClient
  ) {
    super();
  }
  //#endregion

  //#region Private properties
  private readonly _progressTypeControllerUrl: string = "/api/ProgressType";
  //#endregion

  //#region Public methods
  public list$(): Observable<ProgressTypeDto[]> {
    const url: string = this._progressTypeControllerUrl;

    return super.catchErrorResponse(this._httpClient.get<ProgressTypeDto[]>(url));
  }
  //#endregion
}
